"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.IconMenu = function (_a) {
    var color = _a.color, style = _a.style;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 175", style: style },
        React.createElement("g", { fill: "none", stroke: color, strokeWidth: "25" },
            React.createElement("path", { d: "M0 12.5h256-3.96M0 87.5h256-3.96M0 162.5h256-3.96" }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/IconMenu.tsx
// module id = 310
// module chunks = 0